/*
 ** Optimize code
 */
export const init = () => {
  const script = document.createElement('script');
  script.src = 'https://www.googleoptimize.com/optimize.js?id=OPT-TSBMWBD';
  document.head.appendChild(script);
};
